module.exports = __webpack_public_path__ + "img/icon-boshidian@2x.a4624ae4.png";